export default __webpack_public_path__ + "static/media/kitchen4-afterF-1920w.a9b150a1.webp";